
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '@dhis2/ui';

export const VerificationSent = () => {
    const location = useLocation();
    const email = location.state?.email || 'your email address';

    // Inline styles as a single object for clarity
    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh',
            padding: '20px',
            backgroundColor: '#f0f4f8',
            fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
        },
        card: {
            maxWidth: '480px',
            width: '100%',
            backgroundColor: '#ffffff',
            borderRadius: '16px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            overflow: 'hidden',
        },
        header: {
            background: 'linear-gradient(135deg, #4a90e2 0%, #2c6693 100%)',
            padding: '36px 24px 28px',
            textAlign: 'center',
        },
        iconWrapper: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.18)',
            marginBottom: '14px',
        },
        iconSvg: {
            width: '36px',
            height: '36px',
            fill: 'none',
            stroke: '#ffffff',
            strokeWidth: '2',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
        },
        title: {
            margin: 0,
            color: '#ffffff',
            fontSize: '24px',
            fontWeight: '600',
            letterSpacing: '-0.3px',
        },
        body: {
            padding: '30px 28px 32px',
        },
        message: {
            fontSize: '16px',
            lineHeight: '1.7',
            color: '#2d3748',
            marginTop: 0,
            marginBottom: '22px',
        },
        infoBox: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            padding: '14px 16px',
            marginBottom: '28px',
            borderLeft: '4px solid #f6ad55',
        },
        infoIcon: {
            fontSize: '18px',
            lineHeight: '1.4',
            marginRight: '2px',
        },
        infoText: {
            fontSize: '14px',
            color: '#4a5568',
            lineHeight: '1.5',
        },
        buttonGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            alignItems: 'center',
        },
        linkButton: {
            color: '#4a90e2',
            textDecoration: 'none',
            fontSize: '15px',
            fontWeight: '500',
            padding: '10px 0',
            cursor: 'pointer',
            transition: 'color 0.2s',
        },
        linkButtonHover: {
            color: '#2c6693',
            textDecoration: 'underline',
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* Header with icon */}
                <div style={styles.header}>
                    <div style={styles.iconWrapper}>
                        <svg
                            style={styles.iconSvg}
                            viewBox="0 0 24 24"
                        >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                        </svg>
                    </div>
                    <h1 style={styles.title}>Verify Your Email</h1>
                </div>

                {/* Body */}
                <div style={styles.body}>
                    <p style={styles.message}>
                        We've sent a verification link to <strong>{email}</strong>.
                        Please check your inbox and click the link to verify your account.
                    </p>

                    <div style={styles.infoBox}>
                        <span style={styles.infoIcon}>⏰</span>
                        <span style={styles.infoText}>
                            The link expires in <strong>24 hours</strong>. If you don't see the email, check your spam folder.
                        </span>
                    </div>

                    <div style={styles.buttonGroup}>
                        <Button
                            primary
                            onClick={() => window.location.reload()}
                            style={{ width: '100%' }}
                        >
                            Resend Verification Email
                        </Button>
                        <Link
                            to="/login"
                            style={styles.linkButton}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.color = '#2c6693';
                                e.currentTarget.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.color = '#4a90e2';
                                e.currentTarget.style.textDecoration = 'none';
                            }}
                        >
                            Back to Login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerificationSent;